var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "268px",
    height: "320px",
    viewBox: "0 0 268 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Marker-A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 134.279776,
    cy: 134.279776,
    r: 98.83015
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marker-A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.279776, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3296358,39.3296358 C91.7691501,-13.1098786 176.790402,-13.1098786 229.229916,39.3296358 C281.66943,91.7691501 281.66943,176.790402 229.229916,229.229916 L144.829791,313.63004 C139.003179,319.456653 129.556373,319.456653 123.72976,313.63004 L39.3296358,229.229916 C-13.1098786,176.790402 -13.1098786,91.7691501 39.3296358,39.3296358 Z",
    id: "Marker",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Kreis",
    fill: "#FBEBD4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A",
    mask: "url(#mask-2)",
    fill: "#EDAF51",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.897551, 81.794062)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.988,103.32 L111.7332,103.32 L65.5344,0 L46.3464,0 L0,103.32 L18.5976,103.32 L28.044,81.918 L83.5416,81.918 L92.988,103.32 Z M55.7928,17.4168 L76.8996,66.2724 L34.686,66.2724 L55.7928,17.4168 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinA);
export default __webpack_public_path__ + "static/media/pin-a.d56f0a938833de529953370e7edd2aba.svg";
export { ForwardRef as ReactComponent };